import { Link } from "react-router-dom";
import { GridCardItem } from "models/Base";
import styles from "./style.module.scss";

interface IProps {
  item: GridCardItem;
}

export default function GridCard({ item }: Readonly<IProps>) {
  return (
    <Link to={item.link} className={styles.haulpayGridCard}>
      <label className="text-lg">{item.label}</label>
      <item.icon className="flex-none mt-auto ml-auto" />
    </Link>
  );
}
